<template>
    <div >
      <Card>
            <p slot="title">
                Terima Surat Jalan
            </p>
            <Button 
              type="primary" 
              slot="extra"
              :loading="loadingSearch"
              @click="getUnreceived" 
              icon="ios-search" 
              size="small"  >
                <span v-if="!loadingSearch">Search</span>
                <span v-else>Wait.....</span>

            </Button>

            <Alert 
              v-show="containers.length > 0"
              type="success">Found {{containers.length}} Container</Alert>

            <div v-for="container in containers">
              <cInvoiceReceive
                :container="container"
                @setInvoiceChanged="setInvoiceChanged"></cInvoiceReceive>
              <br>
            </div>
        </Card>
        <div class="footer" >
            <Button v-show="invoicesToUpdateMinimize.length > 0"
              type="primary" 
              :loading="loadingPost"
              @click="postReceived" 
              icon="checkmark-round" 
              size="small"  >
                <span v-if="!loadingPost">Submit</span>
                <span v-else>Wait.....</span>
              
              </Button>
        </div>        
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import cInvoiceReceive from '@/components/invoice/cInvoiceReceive'

export default {
  components : {cInvoiceReceive},
  data: () => ({
    containers : [],
    invoicesToUpdate : [],
    invoicesToUpdateMinimize : [],
    loadingSearch: false,
    loadingPost: false,

  }),
  methods: {
      getUnreceived: function(){
        this.loadingSearch  = true;
        HTTP
          .get('invoice/unreceived')
          .then(response => {

            this.containers = []
            this.invoicesToUpdate = []
            this.invoicesToUpdateMinimize = []
            let invoicesToUpdate = [];        

            _.forEach(response.data, function(value) {
                let invoice = {
                    invoiceid : value.invoiceid,
                    isReceivedDo : false,
                    notes : ''
                }

                invoicesToUpdate.push(invoice);
            });

            this.invoicesToUpdate = invoicesToUpdate;
            let invoiceGrouped = groupBy(response.data, 'packaging_list.containerid', 'containerid', 'invoices')
            
            this.containers = invoiceGrouped
            
            this.loadingSearch  = false;
          })
          .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
          })
      },

      postReceived: function()
      {
        this.loadingPost = true
        HTTP
          .post('invoice/receiveDo', {
              invoices: this.invoicesToUpdateMinimize
          })                      
          .then(response => {

            this.loadingPost = false
            this.containers = []
            this.invoicesToUpdate = []
            this.invoicesToUpdateMinimize = []
            
            this.getUnreceived();
          })
          .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
          });
      },
      setInvoiceChanged: function(invoiceChanged) {
          this.updateInvoiceChanged(invoiceChanged)
      },
      updateInvoiceChanged: function(invoiceChanged) {
        var index = _.findIndex(this.invoicesToUpdate, { invoiceid: invoiceChanged.invoiceid });
        this.invoicesToUpdate.splice(index, 1, invoiceChanged);
        this.invoicesToUpdateMinimize = _.reject(this.invoicesToUpdate, { isReceivedDo: false, notes: '' });
      }      
  },
  created() {
    // this.getUnreceived();
  }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// InvoiceReceive.vue?0b29aa56